export var PositionType;
(function (PositionType) {
  PositionType["TOPRIGHT"] = "topright";
  PositionType["TOPLEFT"] = "topleft";
  PositionType["BOTTOMRIGHT"] = "bottomright";
  PositionType["BOTTOMLEFT"] = "bottomleft";
  PositionType["TOPCENTER"] = "topcenter";
  PositionType["BOTTOMCENTER"] = "bottomcenter";
  PositionType["LEFTCENTER"] = "leftcenter";
  PositionType["RIGHTCENTER"] = "rightcenter";
  PositionType["LEFTTOP"] = "lefttop";
  PositionType["RIGHTTOP"] = "righttop";
  PositionType["LEFTBOTTOM"] = "leftbottom";
  PositionType["RIGHTBOTTOM"] = "rightbottom";
})(PositionType || (PositionType = {}));